import { Col, Row } from 'react-bootstrap';
import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ContainerBlue from '../../../components/common/Container/ContainerBlue';
import Datepicker from '../../../components/common/Datepicker/Datepicker';
import DropdownList from '../../../components/common/Dropdown/DropdownList';
import BlueCommonBtn from '../../../components/common/Buttons/BlueCommonBtn';
import GrayCommonBtn from '../../../components/common/Buttons/GrayCommonBtn';
import { DROPDOWN_GENDER, DROPDOWN_ROLE } from '../../../constants/testIds';
import OutcomeBar from '../../../components/common/OutcomeBar';
import { useTempEdgeTranslator } from '../../../Hooks/useTranslation';
import { validateEmail } from '../../../utils/ReGexs';
import { onlyLetters, userLetters } from '../../../utils/stringConversion';
import eyeClose from '../../Login/assets/eye_close.png';
import eyeOpen from '../../Login/assets/eye_open.png';
import { Schema } from './Schema';

function WizardFirstPage({ next, changeFormikValues, data, roles, message, resetFormikValues, stepper }) {
  const navigate = useNavigate();
  const { tempedgeTranslator, locale } = useTempEdgeTranslator();
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleCancel = (isEdit, resetForm) => {
    if (isEdit) {
      resetFormikValues();
      navigate(`/user/list/${locale}`);
    } else {
      resetForm();
      resetFormikValues();
    }
  };

  return (
    <ContainerBlue title={data?.edit ? 'com.tempedge.msg.title.updateaccount' : 'com.tempedge.msg.title.newaccount'} width={1280}>
      {stepper}
      {message && <OutcomeBar response={message} />}
      <Formik
        enableReinitialize
        initialValues={data}
        validationSchema={Schema}
        onSubmit={(values) => {
          changeFormikValues(values);
          next();
        }}
      >
        {({ errors, touched, values, setFieldValue, resetForm, setFieldError }) => (
          <Form>
            <div className="form-group row">
              <div className="col-md-4">
                <label className="control-label">{tempedgeTranslator('com.tempedge.msg.label.firstname')}</label>
                <input
                  className={`form-control tempEdge-input-box 
                            ${
                              errors.account && touched.account && errors.account.firstName && touched.account.firstName ? 'has-error' : ''
                            }`}
                  name="firstName"
                  type="text"
                  value={values.account.firstName || ''}
                  placeholder={tempedgeTranslator('com.tempedge.msg.label.firstname')}
                  onChange={(event) => {
                    event.target.value = onlyLetters(event.target.value).toUpperCase();
                    setFieldValue('account.firstName', event.target.value);
                  }}
                />
              </div>
              <div className="col-md-4">
                <label className="control-label">{tempedgeTranslator('com.tempedge.msg.label.middlename')}</label>
                <input
                  className={`form-control tempEdge-input-box 
                            ${
                              errors.account && touched.account && errors.account.middleName && touched.account.middleName
                                ? 'has-error'
                                : ''
                            }`}
                  name="middlename"
                  type="text"
                  placeholder={tempedgeTranslator('com.tempedge.msg.label.middlename')}
                  value={values.account.middleName || ''}
                  onChange={(event) => {
                    event.target.value = onlyLetters(event.target.value).toUpperCase();
                    setFieldValue('account.middleName', event.target.value);
                  }}
                />
              </div>
              <div className="col-md-4">
                <label className="control-label">{tempedgeTranslator('com.tempedge.msg.label.lastname')}</label>
                <input
                  className={`form-control tempEdge-input-box 
                            ${errors.account && touched.account && errors.account.lastName && touched.account.lastName ? 'has-error' : ''}`}
                  name="lastname"
                  type="text"
                  value={values.account.lastName || ''}
                  placeholder={tempedgeTranslator('com.tempedge.msg.label.lastname')}
                  onChange={(event) => {
                    event.target.value = onlyLetters(event.target.value).toUpperCase();
                    setFieldValue('account.lastName', event.target.value);
                  }}
                />
              </div>
            </div>
            <div className="form-group row">
              <div className="col-md-4">
                <label className="control-label">{tempedgeTranslator('com.tempedge.msg.label.gender')}</label>
                <DropdownList
                  data={[
                    {
                      value: 0,
                      label: tempedgeTranslator('com.tempedge.msg.label.gender.male')
                    },
                    {
                      value: 1,
                      label: tempedgeTranslator('com.tempedge.msg.label.gender.female')
                    },
                    {
                      value: 2,
                      label: tempedgeTranslator('com.tempedge.msg.label.select')
                    }
                  ]}
                  valueField="value"
                  data-testid={DROPDOWN_GENDER}
                  textField="label"
                  value={values.account.gender !== '' ? { value: values.account.gender } : null}
                  onChange={(gender) => {
                    setFieldValue('account.gender', gender.value);
                  }}
                  isInvalid={errors.account && touched.account && errors.account.gender && touched.account.gender}
                  name={'gender'}
                />
              </div>
              <div className="col-md-4">
                <label className="control-label">{tempedgeTranslator('com.tempedge.msg.label.email')}</label>
                <input
                  className={`form-control tempEdge-input-box 
                                ${errors.account && errors.account.email ? 'has-error' : ''}`}
                  name="email"
                  type="email"
                  value={values.account.email || ''}
                  placeholder={tempedgeTranslator('com.tempedge.msg.label.email')}
                  onChange={(event) => {
                    event.target.value = event.target.value.toUpperCase();
                    setFieldValue('account.email', event.target.value);
                  }}
                  onBlur={(event) => {
                    if (event.target.value.trim() !== '') {
                      if (!validateEmail(event.target.value)) {
                        setFieldError('account.email', 'required');
                      }
                    }
                  }}
                />
              </div>
              <div className="col-md-4">
                <label className="control-label">{tempedgeTranslator('com.tempedge.msg.label.birthday')}</label>
                <Datepicker
                  customClass={`form-control tempEdge-input-box
                                     ${
                                       errors.account && touched.account && errors.account.birthDay && touched.account.birthDay
                                         ? 'has-error'
                                         : ''
                                     }`}
                  selectedValue={values.account.birthDay}
                  onChange={(date) => {
                    setFieldValue('account.birthDay', date);
                  }}
                />
              </div>
            </div>
            {/* this is client or offices information */}
            {!data.edit && (
              <div className="form-group row ">
                <div className="col-md-4">
                  <label className="control-label top-label-agency-form">{tempedgeTranslator('com.tempedge.msg.label.role')}</label>
                  <DropdownList
                    data={roles}
                    valueField="roleId"
                    textField="name"
                    value={values.user.role}
                    data-testid={DROPDOWN_ROLE}
                    onChange={(role) => {
                      setFieldValue('user.role', role);
                    }}
                    isInvalid={errors.user && touched.user && errors.user.role && touched.user.role}
                    name={'role'}
                  />
                </div>
                <div className="col-md-4 ">
                  <label className="control-label">{tempedgeTranslator('com.tempedge.msg.label.organization')}</label>
                  <input
                    className={`form-control tempEdge-input-box 
                             ${errors.user && touched.user && errors.user.orgName && touched.user.orgName ? 'has-error' : ''}`}
                    name="orgName"
                    type="text"
                    placeholder={tempedgeTranslator('com.tempedge.msg.label.organization')}
                    value={values.user.orgName}
                    onChange={(event) => {
                      event.target.value = onlyLetters(event.target.value).toUpperCase();
                      setFieldValue('user.orgName', event.target.value);
                    }}
                  />
                </div>
                <div className="col-md-4 ">
                  {values.user.role && values.user.role.name && values.user.role.name.indexOf('CLIENT') >= 0 && (
                    <>
                      <label className="control-label">{tempedgeTranslator('com.tempedge.msg.label.client')}</label>
                      <input
                        className={`form-control tempEdge-input-box 
                                     ${
                                       errors.user && touched.user && errors.user.agencyclient && touched.user.agencyclient
                                         ? 'has-error'
                                         : ''
                                     }`}
                        name="agencyclient"
                        type="text"
                        placeholder={tempedgeTranslator('com.tempedge.msg.label.client')}
                        value={values.user.agencyclient || ''}
                        onChange={(event) => {
                          event.target.value = onlyLetters(event.target.value).toUpperCase();
                          setFieldValue('user.agencyclient', event.target.value);
                        }}
                      />
                    </>
                  )}
                  {values.user.role && values.user.role.name && values.user.role.name.indexOf('CLIENT') < 0 && (
                    <>
                      <label className="control-label">{tempedgeTranslator('com.tempedge.msg.label.office')}</label>
                      <input
                        className={`form-control tempEdge-input-box 
                                       ${
                                         errors.user && touched.user && errors.user.agencyoffice && touched.user.agencyoffice
                                           ? 'has-error'
                                           : ''
                                       }`}
                        name="office"
                        type="text"
                        value={values.user.agencyoffice || ''}
                        placeholder={tempedgeTranslator('com.tempedge.msg.label.office')}
                        onChange={(event) => {
                          event.target.value = onlyLetters(event.target.value).toUpperCase();
                          setFieldValue('user.agencyoffice', event.target.value);
                        }}
                      />
                    </>
                  )}
                </div>
              </div>
            )}
            {/* this is username and password */}
            <div className="form-group row">
              <div className="col-md-4">
                <label className="control-label">{tempedgeTranslator('com.tempedge.msg.label.username')}</label>
                <input
                  className={`form-control tempEdge-input-box 
                                ${
                                  errors.account && touched.account && errors.account.username && touched.account.username
                                    ? 'has-error'
                                    : ''
                                }`}
                  name="email"
                  type="text"
                  maxLength={'30'}
                  autoComplete="new-username"
                  disabled={values.edit}
                  placeholder={tempedgeTranslator('com.tempedge.msg.label.username')}
                  value={values.account.username}
                  onChange={(event) => {
                    event.target.value = userLetters(event.target.value).toUpperCase();
                    setFieldValue('account.username', event.target.value);
                  }}
                />
              </div>
              <div className="col-md-4" style={{ position: 'relative' }}>
                <label className="control-label">{tempedgeTranslator('com.tempedge.msg.label.password')}</label>
                <input
                  className={`form-control tempEdge-input-box ${
                    errors.account && touched.account && errors.account.password && touched.account.password ? 'has-error' : ''
                  }`}
                  name="password"
                  type={showNewPassword ? 'text' : 'password'}
                  pattern="^(?=.*\d)(?=.*[\u0021-\u002b\u003c-\u0040])(?=.*[A-Z])(?=.*[a-z])\S{10,16}$"
                  autoComplete="new-password"
                  disabled={values.edit}
                  value={values.account.password}
                  placeholder={tempedgeTranslator('com.tempedge.msg.label.password')}
                  onChange={(event) => {
                    setFieldValue('account.password', event.target.value);
                  }}
                />
                <img
                  src={showNewPassword ? eyeOpen : eyeClose}
                  className="password-icon"
                  onClick={() => setShowNewPassword(!showNewPassword)}
                  alt="Toggle Password Visibility"
                  style={{ marginRight: '10px' }}
                />
              </div>

              <div className="col-md-4" style={{ position: 'relative' }}>
                <label className="control-label">{tempedgeTranslator('com.tempedge.msg.label.confirmpassword')}</label>
                <input
                  className={`form-control tempEdge-input-box ${
                    errors.account && touched.account && errors.account.passwordConfirmation && touched.account.passwordConfirmation
                      ? 'has-error'
                      : ''
                  }`}
                  name="passwordConfirmation"
                  type={showConfirmPassword ? 'text' : 'password'}
                  disabled={values.edit}
                  pattern="^(?=.*\d)(?=.*[\u0021-\u002b\u003c-\u0040])(?=.*[A-Z])(?=.*[a-z])\S{10,16}$"
                  value={values.account.passwordConfirmation}
                  placeholder={tempedgeTranslator('com.tempedge.msg.label.confirmpassword')}
                  onChange={(event) => {
                    setFieldValue('account.passwordConfirmation', event.target.value);
                  }}
                />
                <img
                  src={showConfirmPassword ? eyeOpen : eyeClose}
                  className="password-icon"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  alt="Toggle Password Visibility"
                  style={{ marginRight: '10px' }}
                />
              </div>
            </div>
            <div className="user-form-actions">
              <Row className="prev-next-btns-agency justify-content-center">
                <Col sm={12} md={5} lg={5}>
                  <GrayCommonBtn
                    tag="com.tempedge.msg.label.cancel"
                    onClick={() => handleCancel(values.edit, resetForm)}
                    data-testid="user-wizard-first-cancel-button"
                  />
                </Col>
                <Col sm={12} md={5} lg={5}>
                  <BlueCommonBtn tag="com.tempedge.msg.label.next" data-testid="user-wizard-first-next-button" />
                </Col>
              </Row>
            </div>
          </Form>
        )}
      </Formik>
    </ContainerBlue>
  );
}

export default WizardFirstPage;
